import { render } from "./unlink-organisation-warning-modal.vue?vue&type=template&id=2dc885ab&ts=true"
import script from "./unlink-organisation-warning-modal.ts?vue&type=script&lang=ts&external"
export * from "./unlink-organisation-warning-modal.ts?vue&type=script&lang=ts&external"

import "./unlink-organisation-warning-modal.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__